import { render, staticRenderFns } from "./Classes.vue?vue&type=template&id=94da7aae&"
import script from "./Classes.vue?vue&type=script&lang=ts&"
export * from "./Classes.vue?vue&type=script&lang=ts&"
import style0 from "./Classes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports